import client from '../../../client';
import { useMutation } from '@tanstack/react-query';
import type {
  AuthControllerRegisterUserIfHeIsNotRegisteredYetMutationRequest,
  AuthControllerRegisterUserIfHeIsNotRegisteredYetMutationResponse,
  AuthControllerRegisterUserIfHeIsNotRegisteredYet400,
  AuthControllerRegisterUserIfHeIsNotRegisteredYet401,
  AuthControllerRegisterUserIfHeIsNotRegisteredYet403,
} from '../../types/AuthControllerRegisterUserIfHeIsNotRegisteredYet';
import type { UseMutationOptions } from '@tanstack/react-query';

type AuthControllerRegisterUserIfHeIsNotRegisteredYetClient = typeof client<
  AuthControllerRegisterUserIfHeIsNotRegisteredYetMutationResponse,
  | AuthControllerRegisterUserIfHeIsNotRegisteredYet400
  | AuthControllerRegisterUserIfHeIsNotRegisteredYet401
  | AuthControllerRegisterUserIfHeIsNotRegisteredYet403,
  AuthControllerRegisterUserIfHeIsNotRegisteredYetMutationRequest
>;
type AuthControllerRegisterUserIfHeIsNotRegisteredYet = {
  data: AuthControllerRegisterUserIfHeIsNotRegisteredYetMutationResponse;
  error:
    | AuthControllerRegisterUserIfHeIsNotRegisteredYet400
    | AuthControllerRegisterUserIfHeIsNotRegisteredYet401
    | AuthControllerRegisterUserIfHeIsNotRegisteredYet403;
  request: AuthControllerRegisterUserIfHeIsNotRegisteredYetMutationRequest;
  pathParams: never;
  queryParams: never;
  headerParams: never;
  response: Awaited<
    ReturnType<AuthControllerRegisterUserIfHeIsNotRegisteredYetClient>
  >;
  client: {
    parameters: Partial<
      Parameters<AuthControllerRegisterUserIfHeIsNotRegisteredYetClient>[0]
    >;
    return: Awaited<
      ReturnType<AuthControllerRegisterUserIfHeIsNotRegisteredYetClient>
    >;
  };
};
/**
 * @link /v2/auth
 */
export function useAuthControllerRegisterUserIfHeIsNotRegisteredYet(
  options: {
    mutation?: UseMutationOptions<
      AuthControllerRegisterUserIfHeIsNotRegisteredYet['response'],
      AuthControllerRegisterUserIfHeIsNotRegisteredYet['error'],
      AuthControllerRegisterUserIfHeIsNotRegisteredYet['request']
    >;
    client?: AuthControllerRegisterUserIfHeIsNotRegisteredYet['client']['parameters'];
  } = {},
) {
  const { mutation: mutationOptions, client: clientOptions = {} } =
    options ?? {};
  return useMutation({
    mutationFn: async (data) => {
      const res = await client<
        AuthControllerRegisterUserIfHeIsNotRegisteredYet['data'],
        AuthControllerRegisterUserIfHeIsNotRegisteredYet['error'],
        AuthControllerRegisterUserIfHeIsNotRegisteredYet['request']
      >({
        method: 'post',
        url: `/v2/auth`,
        data,
        ...clientOptions,
      });

      return res;
    },
    ...mutationOptions,
  });
}
